import { useTranslation } from 'react-i18next';

interface TimeAxisProps {
  timeSlots: string[];
}

export default function TimeAxis({ timeSlots }: TimeAxisProps) {
  const { i18n } = useTranslation();

  const formatTime = (timeStr: string) => {
    const [h, m] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(h, m, 0, 0);
    return new Intl.DateTimeFormat(i18n.language || 'es', { hour: 'numeric', minute: '2-digit' }).format(date);
  };

  return (
    <div data-ui="time-axis-region-001" className="w-20 flex-shrink-0 border-r border-white/10 bg-black/80 z-30 sticky left-0 shadow-[4px_0_10px_rgba(0,0,0,0.5)]">
      {/* Empty corner covering Day and Room headers */}
      <div data-ui="time-axis-region-002" className="h-[88px] border-b border-white/10 flex flex-col items-end justify-end p-2 bg-black/90 sticky top-0 z-50">
        <span className="text-xs text-white/40 uppercase">GMT</span>
      </div>

      {timeSlots.map((time, i) => (
        <div
          data-ui="time-axis-region-003"
          data-slot-boundary={time.endsWith(':00') ? 'hour' : 'half-hour'}
          key={time}
          className="h-12 border-b border-white/5 relative"
        >
          {i % 2 === 0 && (
            <span className="absolute -top-3 right-2 text-[10px] text-gray-400 font-medium bg-black/80 px-1 rounded">
              {formatTime(time)}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
